export const SdgData = [
  {
    id: 3,
    title: "Obiettivo 3 Salute e Benessere",
    name: "Salute e Benessere",
    desc: "Assicurare la salute e il benessere per tutti e per tutte le età."
  },
  {
    id: 4,
    title: "Obiettivo 4 Istruzione di qualità",
    name: "Istruzione di qualità",
    desc:
      "Fornire un'educazione di qualità, equa e inclusiva, e opportunità di apprendimento per tutti."
  },
  {
    id: 5,
    title: "Obiettivo 5 Uguaglianza di genere",
    name: "Uguaglianza di genere",
    desc:
      "Raggiungere l'uguaglianza di genere ed emancipare tutte le donne e le ragazze."
  },
  {
    id: 6,
    title: "Obiettivo 6 Acqua pulita e igiene",
    name: "Acqua pulita e igiene",
    desc:
      "Garantire a tutti la disponibilità e la gestione sostenibile dell'acqua e delle strutture igienico-sanitarie."
  },
  {
    id: 7,
    title: "Obiettivo 7 Energia pulita e accessibile",
    name: "Energia pulita e accessibile",
    desc:
      "Assicurare a tutti l'accesso a sistemi di energia economici, affidabili, sostenibili e moderni."
  },
  {
    id: 8,
    title: "Obiettivo 8 Lavoro dignitoso e crescita economica",
    name: "Lavoro dignitoso e crescita economica",
    desc:
      "Incentivare una crescita economica duratura, inclusiva e sostenibile, un'occupazione piena e produttiva ed un lavoro dignitoso per tutti."
  },
  {
    id: 9,
    title: "Obiettivo 9 Industria innovazione e infrastrutture",
    name: "Industria innovazione e infrastrutture",
    desc:
      "Costruire un'infrastruttura resiliente e promuovere l'innovazione ed una industrializzazione equa, responsabile e sostenibile."
  },
  {
    id: 10,
    title: "Obiettivo 10 Ridurre le disuguaglianze ",
    name: "Ridurre le disuguaglianze ",
    desc: "Ridurre le disuguaglianze all'interno e fra le nazioni."
  },
  {
    id: 11,
    title: "Obiettivo 11: Città e comunità sostenibili  ",
    name: "Città e comunità sostenibili  ",
    desc:
      "Rendere la città e gli insediamenti umani inclusivi, sicuri, duraturi e sostenibili."
  },
  {
    id: 12,
    title: "Obiettivo 12:  Consumo e produzione responsabili ",
    name: "Consumo e produzione responsabili ",
    desc: "Garantire modelli sostenibili di produzione e di consumo."
  },
  {
    id: 13,
    title: "Obiettivo 13: Agire per il clima ",
    name: "Agire per il clima ",
    desc:
      "Promuovere azioni, a tutti i livelli, per combattere il cambiamento climatico."
  },
  {
    id: 14,
    title: "Obiettivo 14: La vita sott'Acqua ",
    name: "La vita sott'Acqua ",
    desc:
      "Conservare e utilizzare in modo durevole gli oceani, i mari e le risorse marine per uno sviluppo sostenibile."
  },
  {
    id: 15,
    title: "Obiettivo 15: La vita sulla terra",
    name: "La vita sulla terra",
    desc:
      "Proteggere, ripristinare e favorire un uso sostenibile dell'ecosistema terrestre."
  },
  {
    id: 16,
    title: "Obiettivo 16: Pace, giustizia e istituzioni forti",
    name: "Pace, giustizia e istituzioni forti",
    desc:
      "Promuovere società pacifiche e più inclusive per uno sviluppo sostenibile; offrire l'accesso alla giustizia per tutti."
  },
  {
    id: 17,
    title: "Obiettivo 17: Partnership per gli obiettivi",
    name: "Partnership per gli obiettivi",
    desc:
      "Rafforzare i mezzi di attuazione e rinnovare il paternariato mondiale per lo sviluppo sostenibile."
  }
];
